import { Injectable } from '@angular/core';
import { BaseMap } from 'src/app/config/model/basemap-config.model';
import { ConfigService } from '../../config/config.service';
import { EsriBasemap } from '../../config/esri.module';
import { MessageService } from '../../core/service/message.service';
import { LayerContainerService } from './layer-container.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class BaseMapListService
 * @version 0.0.1
 * @since September 2017
 * @description The BaseMapListService provides all basemaps
 * for usage in components
 */
@Injectable({
  providedIn: 'root',
})
export class BaseMapListService {
  private _baseMapList: __esri.Basemap[] = [];

  constructor(
    private _configService: ConfigService,
    private _layerContainerService: LayerContainerService,
    private _messageService: MessageService,
    private translateService: TranslateService
  ) {
    this._configService.baseMapConfig.basemaps.forEach(bm => {
      const baseMap = this.createBaseMap(bm);
      this._baseMapList.push(baseMap);
    });
  }

  get baseMapList(): __esri.Basemap[] {
    return this._baseMapList;
  }

  private createBaseMap(bm: BaseMap): __esri.Basemap {
    const basePath = this._configService.baseUrl;
    if (!basePath) {
      this._messageService.error('NOTIFICATIONS.ERROR.ENVIRONMENT.BASE_PATH');
      return;
    }
    // create layers
    const layers: __esri.Layer[] = [];
    bm.layers.forEach(baseLyr => {
      const lyrContainer = this._layerContainerService.layerList.map(f => f.esriLayer);
      const layer = lyrContainer.filter(f => f.id === baseLyr.fkLayer)[0];
      layers.push(layer);
    });

    // create beasemap
    const baseMapProperties: __esri.BasemapProperties = {
      baseLayers: layers,
      title: this.translateService.instant(bm.title),
      thumbnailUrl: bm.thumbnailUrl,
      id: bm.layers[0].fkLayer,
    };

    if (bm.defaultBaseMap) {
      baseMapProperties['defaultBaseMap'] = bm.defaultBaseMap;
    }
    const baseMap = new EsriBasemap(baseMapProperties);

    return baseMap;
  }
}
